import {
  IOrderCancellationReason,
  IOrderPaymentStatus,
  IOrderStatus,
} from "@nju/data-access-portal-order";
import { TextStyleProps } from "@nju/ui";

export const mapOrderStatusName = (status: IOrderStatus): string => {
  const orderState = {
    Completed: "zamówienie zrealizowane",
    PendingCancellation: "zamówienie w trakcie anulowania",
    Cancelled: "zamówienie anulowane",
    FulfillmentFinishing: "oczekiwanie na konfigurację usługi",
    InProgressFulfillment: "oczekiwanie na dostarczenie usługi",
    InProgressPayment: "oczekiwanie na potwierdzenie płatności",
    InProgressDelivery: "oczekiwanie na dostawę",
    Submitted: "zamówienie złożone",
    Draft: "zamówienie niepotwierdzone",
    SubmitFailed: "błąd po zatwierdzeniu zamówienia",
  };

  return orderState[status];
};

export const mapOrderPaymentStatusName = (status: IOrderPaymentStatus) => {
  const paymentState = {
    NEW: "nowa",
    PENDING: "w trakcie",
    PENDING_REPEATING: "w trakcie",
    PENDING_REPEATING_RETRY: "w trakcie",
    COMPLETED: "zapłacono",
    FAILED: "nieudana",
    CANCELLED: "nieudana",
  };

  return paymentState[status];
};

export const mapOrderCancellationReason = (
  cancellationReason: IOrderCancellationReason,
) => {
  const cancellationState = {
    userRequest: "klient anulował zamówienie",
    agentRequest: "doradca anulował zamówienie",
    unsuccessfulDelivery: "nieudana dostawa",
    fulfillmentError: "błąd realizacji zamówienia",
    fulfillmentExpired: "błąd realizacji zamówienia",
    draftExpired: "przeterminowany draft zamówienia",
    orderSubmissionError: "błąd tworzenia zamówienia",
    NOSS_FAILED_BMT: "brak możliwości technicznych",
    NOSS_FAILED_BMK: "brak możliwości klienta",
  };

  return cancellationState[cancellationReason];
};

export const getItemsColor = (
  installationStatus: IOrderStatus | undefined,
  paymentStatus: IOrderPaymentStatus | undefined,
  installationDate: string | undefined,
) => {
  let installationDateColor: TextStyleProps["tone"] = "inherit";
  let installationStatusColor: TextStyleProps["tone"] = "inherit";
  let paymentStatusColor: TextStyleProps["tone"] = "inherit";

  if (
    installationStatus !== "Completed" &&
    installationDate &&
    new Date(installationDate).getTime() < Date.now()
  ) {
    installationDateColor = "alert";
  }
  if (installationStatus === "Completed") {
    installationDateColor = "accent";
    installationStatusColor = "accent";
  }
  if (
    installationStatus === "Cancelled" ||
    installationStatus === "PendingCancellation"
  ) {
    installationStatusColor = "alert";
  }
  if (paymentStatus === "COMPLETED") {
    paymentStatusColor = "accent";
  }
  if (paymentStatus !== "COMPLETED" && installationStatus === "Completed") {
    paymentStatusColor = "alert";
  }

  return { installationDateColor, installationStatusColor, paymentStatusColor };
};
